import { asMessages } from '@core/Utils/Intl/AsMessages';

export const scope = 'containers.component.offerModal';

const definition = asMessages(scope, {
  campaignCount: 'offers',
  campaignLayoutOne: '2 offers',
  campaignLayoutOneTwo: ' apply on this car.',
  findMore: ' Find out more',
  findMoreMobile: ' View more',
  campaignDelivery: 'offers apply. Delivery is free.',
  campaignTitle: 'Our latest offers',
  modalTitle: 'Current offers on this car',
} as const);

export const offerModalMessages = definition.messages;
export const defaultOfferModalMessages = definition.defaultMessages;
export type OfferModalMessages = typeof definition.defaultMessages;
